var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1617006253996,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2825,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M850.2 177.1H173.8c-37.1 0-67 30-67 67v400.4c0 37.1 30 67 67 67H850c37.1 0 67-30 67-67V244.4c0.3-37.1-29.7-67.3-66.8-67.3z m-228 290.7L438.4 574c-15.7 9.1-35.5-2.3-35.5-20.6V341.1c0-18.3 19.8-29.7 35.5-20.6l183.8 106.1c15.8 9.2 15.8 32.1 0 41.2z m62.2 379.1H339.6c-17.5 0-31.7-14.2-31.7-31.7s14.2-31.7 31.7-31.7h344.8c17.5 0 31.7 14.2 31.7 31.7s-14.1 31.7-31.7 31.7z",
    "p-id": 2826
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStart);
export default __webpack_public_path__ + "static/media/icon-start.3d9ed4be83f5ec30d35c57e89600454e.svg";
export { ForwardRef as ReactComponent };